module.exports = __webpack_public_path__ + "img/video.1b93d541.svg";